import {FullscreenPanel, FullscreenPanelBody} from '@yandex-delivery/blocks'
import {memo, useCallback} from 'react'

import {RouteInfo} from '../../../RouteMap/components/RouteInfo/RouteInfo'
import {useRouteInfo} from '../../../RouteMap/components/RouteInfo/useRouteInfo'
import {Props} from './types'

export const EditOrderOfPointsModal = memo<Props>(function EditOrderOfPointsModal(props) {
  const {isActive, setActive} = props

  const close = useCallback(() => {
    setActive?.(false)
  }, [setActive])

  const {routeInfoRef, addresses, handleSave, setAddresses} = useRouteInfo({
    onSave: close,
  })

  return (
    <FullscreenPanel anchor="bottom" opened={isActive}>
      <FullscreenPanelBody>
        <RouteInfo
          ref={routeInfoRef}
          addresses={addresses}
          onClose={close}
          onSave={handleSave}
          setAddresses={setAddresses}
          fullscreen
        />
      </FullscreenPanelBody>
    </FullscreenPanel>
  )
})
